import React, { useState } from "react";
import * as PatientApi from "api/patient.api";
import PatientSearch from "./PatientSearch";
import { connect } from "react-redux";
import { loadPatient } from "store/actions/patient.actions";
import { Patient } from "model/patient.model";
import { RouteComponentProps } from "react-router";
import { GlobalState } from "store/configure-store";
import { selectUser } from "store/reducers/user-context.reducer";
import { dispatchLogout } from "store/actions/user-context.actions";
import { selectTarificationApplicationSession } from "store/reducers/tarification.reducer";
import { User } from "model/user.model";
import { History } from "history";
import { HelenaSessionKey } from "model/helena.model";
import { Brand, Form, Navbar, Page } from "@cc/react-components";
import Icon from "@cc/react-components/Icon";
import HamburgerViewModal from "../HamburgerMenu/HamburgerViewModal";
import { TarificationApplicationSession } from "model/tarification.model";
import { PV_PATIENT_SEARCH } from "common/matomo/track-page-view.constants";
import { useTrackPageView } from "common/matomo/track-page-view.hook";

interface StateFromProps {
  user: User;
  sessionKey: HelenaSessionKey | null;
  tarificationSession: TarificationApplicationSession;
}

interface DispatchFromProps {
  dispatchLogout(): void;

  loadPatient(
    userId: number,
    patientId: number,
    sessionKey: HelenaSessionKey,
    history: History
  ): void;
}

const PatientSearchContainer = ({
  user,
  sessionKey,
  loadPatient,
  tarificationSession,
  history,
}: StateFromProps & DispatchFromProps & RouteComponentProps) => {
  const [searchResults, setSearchResults] = useState<Patient[]>([]);
  const [searchString, setSearchString] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useTrackPageView(PV_PATIENT_SEARCH);

  if (searchString && searchString.length > 0) {
    window.scrollTo(0, 0);
  }

  function noString() {
    return searchString === "";
  }

  const renderHamburgerMenu = () => {
    return (
      <HamburgerViewModal
        show={show}
        onHide={handleClose}
        user={user}
        tarificationSession={tarificationSession}
        tarificationSessionKey={undefined}
      />
    );
  };

  return (
    <>
      {renderHamburgerMenu()}
      <Navbar>
        <Navbar.Brand application="Go Visit" />
        <Icon
          type="menu"
          size="2x"
          className="text-white ml-auto"
          onClick={handleShow}
        />
      </Navbar>
      <Page>
        <Page.Body>
          <div className="h-100 d-flex flex-column align-items-center">
            {noString() && <div className="flex-grow-1" />}
            {noString() && (
              <Brand application="Visit" mobile className="mb-3" />
            )}
            <Form className="w-100">
              <PatientSearch
                searchKey={searchString}
                searchResults={searchResults}
                onSearchPatient={(value: string) =>
                  onSearchPatient(value, setSearchResults, setSearchString)
                }
                onSelectPatient={(patient: Patient) =>
                  onSelectPatient(
                    patient,
                    user,
                    sessionKey,
                    setSearchResults,
                    loadPatient,
                    history
                  )
                }
              />
            </Form>
            {noString() && <div className="flex-grow-1" />}
            {noString() && (
              <p className="text-center text-muted">
                {"1.0." + (process.env.REACT_APP_BUILD_NUMBER || "0")}
              </p>
            )}
          </div>
        </Page.Body>
      </Page>
    </>
  );
};

const onSearchPatient = async (
  value: string,
  setSearchResults: any,
  setSearchString: any
) => {
  setSearchString(value);
  const patientSearchResults = await PatientApi.quickSearch(value);
  setSearchResults(patientSearchResults.slice(0, 5));
};

const onSelectPatient = (
  patient: Patient,
  user: User,
  sessionKey: HelenaSessionKey | null,
  setSearchResults: any,
  loadPatient: any,
  history: History
) => {
  if (patient.id) {
    setSearchResults([]);
    loadPatient(user.id, patient.id, sessionKey, history);
  }
};

const mapStateToProps = (state: GlobalState): StateFromProps => {
  return {
    user: selectUser(state),
    sessionKey: state.helena.sessionKey,
    tarificationSession: selectTarificationApplicationSession(state),
  };
};

export default connect<
  StateFromProps,
  DispatchFromProps,
  RouteComponentProps,
  GlobalState
>(mapStateToProps, { loadPatient, dispatchLogout })(PatientSearchContainer);
